import { useAuth0 } from '@auth0/auth0-react';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import VerifyEmail from '../main/apps/pages/VerifyEmail';
import { getPersonAndUser } from './store/loginSlice';
import { CircularProgress } from '@material-ui/core';
import Hammauth from '../services/hammurabi/auth';
import { toast } from 'react-toastify';

function ProtectedRoute({ component: Component, render, ...rest }) {
	const { isLoading, user, isAuthenticated, getIdTokenClaims } = useAuth0();
	const loginSuccess = useSelector(({ auth }) => auth.login.success);
	const loggedInUser = useSelector(({ auth }) => auth.user);
	const person = useSelector(({ entities }) => entities.person.data);
	const dispatch = useDispatch();
	const [wrongToken, setWrongToken] = React.useState(false);

	const validateToken = useCallback(
		async token => {
			try {
				const response = await Hammauth.validateToken({ token });
				if (response.code === 200) {
					dispatch(getPersonAndUser(user, token));
				} else {
					setWrongToken(true);
				}
			} catch (e) {
				setWrongToken(true);
			}
		},
		[user, rest, dispatch]
	);

	useEffect(() => {
		if (user && !person) {
			setWrongToken(false);
			getIdTokenClaims().then(async claims => {
				const token = claims.__raw;
				validateToken(token);
			});
		}
	}, [setWrongToken, user, person, getIdTokenClaims, dispatch, rest, validateToken]);

	if (wrongToken) {
		toast.error('There was an error with your login information. Please log in again or contact us.');

		return (
			<Redirect
				to={{
					pathname: '/login',
					state: { from: rest.location },
				}}
			/>
		);
	}

	if (isLoading) {
		return (
			<div className='flex h-screen'>
				<div className='m-auto'>
					<CircularProgress />
				</div>
			</div>
		);
	}

	if (!isAuthenticated && !loginSuccess) {
		localStorage.removeItem('HammurabiAuth');

		return (
			<Redirect
				to={{
					pathname: '/login',
					state: { from: rest.location },
				}}
			/>
		);
	}

	if (isAuthenticated && !loginSuccess) {
		return (
			<div className='flex h-screen'>
				<div className='m-auto'>
					<CircularProgress />
				</div>
			</div>
		);
	}

	if (!loginSuccess) {
		return (
			<Redirect
				to={{
					pathname: '/login',
					state: { from: rest.location },
				}}
			/>
		);
	}

	if (!loggedInUser.email_verified) {
		return <VerifyEmail />;
	}

	return (
		<Route
			{...rest}
			render={props => {
				return Component ? <Component {...props} /> : render(props);
			}}
		></Route>
	);
}

export default ProtectedRoute;
